<style scoped>
.buttonRefresh {
  text-align: end;
  padding-bottom: 10px;
}
.tbl-info {
  font-size: 12px;
}
</style>

<template>
  <div>
    <b-row>
      <b-col>
        <p>&nbsp;</p>
        <span class="align-text-bottom tbl-info"
          ><b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.</span
        >
      </b-col>
      <b-col class="buttonRefresh">
        <b-button variant="outline-primary" size="sm" @click="refreshTable"
          >Refresh</b-button
        >
      </b-col>
    </b-row>
    <b-table
      id="data-table-report-list"
      ref="reportListTable"
      select-mode="single"
      selectable
      responsive
      :items="reportData"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="tableFields"
      small
      @row-selected="onRowSelected"
    >
      <template v-slot:cell(approvedStatus)="scope">{{
        formStatus(scope.item.approvedStatus)
      }}</template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      pills
      :total-rows="totalRows"
      :per-page="perPage"
      aria-controls="data-table-report-list"
      align="right"
    ></b-pagination>
  </div>
</template>

<script>
import { formMethods } from '@state/helpers'
export default {
  props: {
    wellId: { type: Number, default: undefined },
    padId: { type: Number, default: undefined },
    fieldId: { type: Number, default: undefined },
    formId: {
      type: Number,
      default: undefined,
    },
    selectedRowTable: {
      type: Function,
      default: function () {},
    },
    formName: String,
    countRowNo: Function,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      reportData: [],
      tableFields: [
        { key: 'submitId', label: 'Report No.', sortable: true },
        { key: 'wellName', label: 'Well Name', sortable: true },
        { key: 'wellboreName', label: 'Wellbore Name', sortable: true },
        { key: 'dateReport', label: 'Report Date', sortable: true },
        { key: 'fullName', label: 'Submitted By', sortable: true },
        { key: 'submittedTime', label: 'Submitted Time', sortable: true },
        { key: 'approvedStatus', label: 'Status', sortable: true },
      ],
      selectedRow: [],
      rowNo: 0,
    }
  },
  computed: {
    totalRows: function () {
      // this.countRowNo({formName:this.formName, value:this.reportData.length})
      return this.reportData.length
    },
  },
  watch: {
    wellId: function (val) {
      this.refreshTable()
    },
    padId: function (val) {
      this.refreshTable()
    },
    fieldId: function (val) {
      this.refreshTable()
    },
  },
  created: function () {
    this.refreshTable()
  },
  methods: {
    ...formMethods,
    onRowSelected(item) {
      this.selectedRow = item
      this.selectedRowTable(item)
    },
    refreshTable() {
      this.reportData = []

      const params = {
        fieldId: this.fieldId,
        padId: this.padId,
        wellId: this.wellId,
        formGroupId: 3,
        formId: this.formId,
      }

      this.getDailyDrillingWitingForApproval({ params: params }).then(
        (resp) => {
          if (resp) {
            this.reportData = resp.data.data
            this.rowNo = this.reportData.length
          }
        }
      )
    },
    formStatus(code) {
      let statusReturn = code
      switch (code) {
        case 1:
          statusReturn = 'DRAFT'
          break
        case 2:
          statusReturn = 'WAITING FOR APPROVAL'
          break
        case 3:
          statusReturn = 'APPROVED'
          break
        case 4:
          statusReturn = 'REJECTED'
          break
        default:
          return code
      }
      return statusReturn
    },
  },
}
</script>